<template>
  <el-form ref="form" :model="passions" label-position="top">
    <h1 class="mb0">About Heart</h1>

    <p class="quote mt1">
      “Delight yourself in the LORD and he will give you the desires of your heart.” Psalms 37:4 (NIV)
    </p>

    <p>
      Another way to think of your heart is to think about passion! Take a moment to think about these questions:
    </p>
    <br>

    <el-row :gutter="60">
      <el-col :md="12">
        <b>What drives you?</b>
        <ul>
          <li>What would you do for God if you knew you couldn't fail?</li>
          <li>What pushes you to action?</li>
          <li>What moves you so deeply that it keeps you awake at night?</li>
        </ul>
      </el-col>
      <el-col :md="12">
        <b>Who are the people you most want to help?</b>
        <ul>
          <li>Who do you feel you can influence the most?</li>
          <li>Is there an age range you feel most drawn to? If so, what age group?</li>
          <li>Is there an affinity group I feel most drawn to?</li>
        </ul>
      </el-col>
    </el-row>

    <el-row :gutter="60">
      <el-col :md="12">
        <b>What are the needs I feel most drawn to?</b>
        <ul>
          <li>What are the top two needs I love to meet for people?</li>
          <li>Why do I love meeting those needs?</li>
        </ul>
      </el-col>
      <el-col :md="12">
        <b>What cause am I most passionate about?</b>
        <ul>
          <li>What cause or issue makes my heart race?</li>
          <li>Where could I make the greatest impact for God?</li>
        </ul>
      </el-col>
    </el-row>

    <div class="passion-group" v-for="group in groups" :key="group.name">
      <h2>Passions - {{ group.name }}</h2>
      <p>Choose at least 1, up to 6.</p>
      <el-form-item
          :prop="group.key"
          :rules="[{ type: 'array', required: true, message: 'Choose at least 1' }, { type: 'array', max: 6, message: 'Choose up to 6' }]">
        <el-checkbox-group
            class="passions"
            :value="getPassionsByGroup(group.key)"
            @input="storePassionsByGroup(group.key, arguments[0])">
          <el-checkbox v-for="option in group.options" :key="option" :label="option" />
          <el-checkbox label="Other">
            <el-input
                :value="getOtherByGroup(group.key)"
                @input="storeOtherByGroup(group.key, arguments[0])"
                @click.native="enableOtherByGroup(group.key)"
                placeholder="Other" />
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </div>

    <ui-form-actions>
      <el-button @click="goBack">Back</el-button>
      <el-button type="primary" @click="goForward">Continue</el-button>
    </ui-form-actions>
  </el-form>
</template>

<script>
  /* eslint-disable max-len */

  import get from 'lodash/get';
  import step from '../mixins/step';
  import validation from '../mixins/validation';

  export default {
    mixins: [step, validation],
    name: 'Gifts',
    methods: {
      goBack() {
        this.$router.back();
      },
      goForward() {
        this.validate().then(() => {
          this.$router.push({ path: '/abilities' });
        }).catch(() => {
        });
      },
      getPassionsByGroup(key) {
        return get(this.passions, key, []);
      },
      storePassionsByGroup(key, passions) {
        this.$store.commit('setPassionsByGroup', { group: key, passions });
      },
      getOtherByGroup(groupName) {
        return get(this.passionsOther, groupName, null);
      },
      storeOtherByGroup(groupName, passion) {
        this.$store.commit('setOtherPassionByGroup', { group: groupName, passion });
      },
      enableOtherByGroup(groupName) {
        const passions = this.getPassionsByGroup(groupName);
        if (passions.indexOf('Other') === -1) {
          this.storePassionsByGroup(groupName, passions.concat(['Other']));
        }
      },
    },
    computed: {
      passions() {
        return this.$store.state.passions;
      },
      passionsOther() {
        return this.$store.state.passionsOther;
      },
    },
    data() {
      return {
        groups: [
          {
            name: 'People',
            key: 'people',
            options: [
              'Children',
              'College',
              'Disabled',
              'Divorced',
              'Elderly',
              'Empty Nesters',
              'Homeless',
              'Hospitalized',
              'Infants',
              'Parents',
              'Poor',
              'Prisoners',
              'Single Parents',
              'Singles',
              'Teen Moms',
              'Unemployed',
              'Widowed',
              'Young Married',
              'Youth',
            ],
          },
          {
            name: 'Issues and Causes',
            key: 'issues',
            options: [
              'Abortion',
              'Abuse/Violence',
              'Addictions',
              'At-Risk Children',
              'Child Care',
              'Compulsive Behavior',
              'Deafness',
              'Discipleship',
              'Economics',
              'Education',
              'Environment',
              'Ethics',
              'Family',
              'Finances',
              'Health/Fitness',
              'HIV/Aids',
              'Human Trafficking',
              'Law/Justice System',
              'Literacy',
              'Marriage/Family',
              'Politics',
              'Poverty',
              'Racism',
              'Sanctity of Life',
              'Spiritual Apathy',
              'Violence',
            ],
          },
        ],
      };
    },
  };
</script>

<style lang="scss">
  @import "~styles/vars";
  @import "~element-theme/mixins/mixins.scss";

  .passions {
    display: flex;
    flex-wrap: wrap;
    .el-checkbox {
      flex-basis: 100%;
      display: block;
      margin: 0 0 .75rem !important;
      @include res(lg) {
        flex-basis: 33.33%;
      }
    }
  }

  .passion-group {
    .el-form-item__error {
      top: -18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Heart.vue